export const countryMap = {
	UK: 'GB',
}

/**
 * Corrects the country code to the correct format - we sometimes get the wrong country code from the data
 * we receive from the source database.
 * @param countryCode - The country code to correct.
 * @returns The corrected country code.
 */
export function correctCountryCode(countryCode: string) {
	return countryMap[countryCode as keyof typeof countryMap] || countryCode
}
